module.exports = __webpack_public_path__ + "static/media/placeholder-model.61de2b21.png";